export const endpoints = {
  auth: {
    userLogin: "/user/loginWithPhone",
    userEmailLogin: "/user/send-email-otp",
    verifyOtp: (id) => `/user/verify-email-otp/${id}`,

    registerUser: "/user/signup",
    forgotPassword: "/user/forget/Password",
    changePassword: (id) => `/user/changePassword/${id}`,
    forgotVerifyOtp: (id) => `/user/forgot/Verifyotp/${id}`,
    verifyOtp: (id) => `/user/${id}`,
  },

  user: {
    profile: {
      registration: "/user/registration",
      login: "/user/login",
      forgetPassword: "/user/forget/Password",
      forgotVerifyOtp: (id) => `/user/forgot/Verifyotp/${id}`,
      changePassword: (id) => `/user/changePassword/${id}`,
      update: "/user/edit/profile",
      getUserProfile: "/user/getprofile",
      getAllUser: "/user/profile",
      getAllUserByType: "/user/profile/by-userType",
      getUserById: (id) => `/user/profile/${id}`,
      getUserRoles: (id) => `/user/${id}/roles`,
      deleteUser: (id) => `/user/users/profile/delete/${id}`,
      updateUserById: (id) => `/user/update/user/${id}`,
      uploadProfilePicture: (id) => `/user/upload-profile-picture/${id}`,
      uploadId: (id) => `/user/upload-id-picture/${id}`,
      uploadCourseVideoImagePdf: "/user/UploadCourseVideoImagePdf",
      searchUser: "/user/searchUser",
      getUserProfile: `/user/profile`
    },
    goalCategory: {
      createGoalCategory: "/user/goal-category",
      getAllGoalCategories: "/user/goal-category",
      getGoalCategoryById: (id) => `/user/goal-category/${id}`,
      updateGoalCategory: (id) => `/user/goal-category/${id}`,
      deleteGoalCategory: (id) => `/user/goal-category/${id}`,
    },
    goal: {
      createGoal: "/user/goals",
      getAllGoals: "/user/goals",
      getAllGoalsByGoalCategory: (id) => `/user/goals/byGoalCaegory/${id}`,
      getGoalById: (id) => `/user/goals/${id}`,
      updateGoal: (id) => `/user/goals/${id}`,
      deleteGoal: (id) => `/user/goals/${id}`,
    },
    subjects: {
      getAll: "/user/subjects",
      getByGoalCategory: "/user/subjects/goal",
    },
    notifications: {
      getAllNotifications: "/user/notifications/user",
      getUnreadNotifications:
        "/user/notifications/getNotificationsForUserUnread",
      markAllAsRead: "/user/notifications/markAll/read",
    },
    courses: {
      getAll: "/user/Category/getAllCategory",
      getById: `/user/courses/byChapter/byCourse/byTopic`,
      askQuestion: (id) => `/user/topics/${id}/qanda`,
      getQa: (id) => `/user/topics/${id}/qanda`,
      getPopularCourses: "/user/courses",
      getCoursePercentage:  `/user/my-courses/byfilter?type=Course`,
    },
    capsuleCourse: {
      getAll: "/user/capsuleCourse",
      create: "/user/capsule-courses",
      get: (id) => `/user/capsule-courses/${id}`,
      update: (id) => `/user/capsule-courses/${id}`,
      delete: (id) => `/user/capsule-courses/${id}`,
    },
    testSeries: {
      getAll: "/user/test-series",
      create: "/user/test-series",
      get: (id) => `/user/test-series/${id}`,
      update: (id) => `/user/test-series/${id}`,
      testSeriesByTestId: (id) => `/user/test-series-file`,
      submitTest: `/user/my-courses/submit-test`,
      trackTest: `/user/my-courses/track/test`,
    },
    handWrittenNotes: {
      getAll: "/user/handwritten-notes",
      getById: (id) => `user/handwritten-notes/${id}`,
    },
    pyq: {
      getAll: "/user/previous-year-questions",
      create: "/user/previous-year-questions",
      getById: (id) => `/user/previous-year-questions/${id}`,
      get: (id) => `/user/pyq/${id}`,
      update: (id) => `/user/pyq/${id}`,
      delete: (id) => `/user/pyq/${id}`,
      pyqByTestId: (id) => `/user/previous-year-questions/test-series-file`,
      pyqTestSubmit: `/user/mycourse/submit-test-performance`,
    },
    currentAffairs: {
      getDailyNews: "/user/currentAffairs",
      getEditorialAnalysis: "/user/currentAffairs",
      getDailyQuiz: "/user/targetCurrentAffairs",
      getTargetCurrentAffairs: "/user/targetCurrentAffairs",
      getYoutubeVideos: "/user/youtubeVideos",
      getTargetCurrentAffairsById: (id) => `/user/targetCurrentAffairs/${id}`,
      getPdf: `/user/pdf`,
    },

    skills: {
      getAll: "/user/skills",
      create: "/user/skills",
      get: (id) => `/user/skills/${id}`,
      update: (id) => `/user/skills/${id}`,
      delete: (id) => `/user/skills/${id}`,
    },
    community: {
      getAll: "/user/posts",
      likePost: (id) => `/user/posts/${id}/like`,
      pinPost: (id) => `/user/posts/${id}/save`,
      addComment: (id) => `/user/posts/${id}/comment`,
      createPost: "/user/posts",
    },
    logs: {
      create: "/user/logs/add",
      getAll: "/user/logs",
      get: (id) => `/user/logs/${id}`,
      update: (id) => `/user/logs/${id}`,
      delete: (id) => `/user/logs/${id}`,
    },
    studyPlanner: {
      getUserPlans: "/user/study-plans",
      createUserPlan: "/user/get/user-study-planner",
      getPlanById: (id) => `/user/study-planners/${id}`,
    },
    cart: {
      getCart: "/user/cart",
      addToCart: "/user/cart/add",
      removeFromCart: `/user/cart/remove`,
      checkOut: `/user/Cart/checkout`,
      placeOrder: (id) => `user/Cart/placeOrder/${id}`,
      startCourse: "/user/my-courses/start",
      startTestDirectly: "/user/mycourse/add-test-performance",
    },
    aboutExam: {
      createAboutExam: "/user/aboutExam",
      getAllAboutExams: "/user/aboutExam",
      getAboutExamsByGoalId: (id) => `/user/aboutExam/byGoal/${id}`,
      updateAboutExam: (id) => `/user/aboutExam/${id}`,
      deleteAboutExam: (id) => `/user/aboutExam/${id}`,
    },
    staticContent: {
      aboutUs: {
        create: "/static/aboutUs",
        update: (id) => `/static/aboutUs/${id}`,
        get: "/static/getAboutUs",
        getById: (id) => `/static/aboutUs/${id}`,
        delete: (id) => `/static/aboutUs/${id}`,
      },
      privacy: {
        create: "/static/createPrivacy",
        update: (id) => `/static/privacy/${id}`,
        get: "/static/getPrivacy",
        getById: (id) => `/static/privacy/${id}`,
        delete: (id) => `/static/privacy/${id}`,
      },
      terms: {
        create: "/static/createTerms",
        update: (id) => `/static/terms/${id}`,
        get: "/static/getTerms",
        getById: (id) => `/static/terms/${id}`,
        delete: (id) => `/static/terms/${id}`,
      },
      faq: {
        create: "/static/faq/createFaq",
        getAll: "/static/faq/All",
        getAllByCategory: (id) => `/faq/Allcategory/${id}`,
        update: (id) => `/static/faq/${id}`,
        getById: (id) => `/static/faq/${id}`,
        delete: (id) => `/static/faq/${id}`,
      },
      callUs: {
        create: "/user/call/us",
        getAll: "/user/call-us",
        getById: (id) => `/user/call-us/${id}`,
        update: (id) => `/user/call-us/${id}`,
        delete: (id) => `/user/call-us/${id}`,
      },
      banner: {
        create: "/user/Banner/AddBanner",
        getAll: "/admin/Banner/allBanner",
        getByPosition: "/user/Banner/bannerByPosition",
        updatePosition: (id) => `/user/Banner/updateBanner/${id}`,
        getById: (id) => `/user/Banner/getBannerById/${id}`,
        delete: (id) => `/user/Banner/deleteBanner/${id}`,
      },
    },
    settingPage: {
      getUser: "/user/profile",
      updateProfile: "/user/edit/profile",
      updateProfilePicture: "/user/upload-profile-picture",
      getPurchasedCourses: "/user/my-courses/byfilter",
      getTimeLine: "/user/logs/getWeeklySummary",
    },
    university: {
      getAll: "/user/goal-category",
      // getAll: "/user/university",
    },
    universityCourse: {
      getAll: "/user/UniversityCourse",
      getByUniversity: (id) => `/user/goals/byGoalCaegory/${id}`,
    },
    semesterExam: {
      getAll: "/user/semester",
    },

    testMonial: {
      getAll: "/user/testimonial",
    },
    faq: {
      getAll: "/static/faq/All",
    },
    aboutUs: {
      getAll: "/static/getAboutUs",
    },
    topContent: {
      getAll: "/user/top-content",
    },
    subscription: {
      getAll: "/user/subscription",
      getAllCourses: "/user/courses",
    },
    job: {
      getAll: "/user/placement-job",
      getById: (id) => `/user/placement-job/${id}`,
      applyJob: (id) => `/user/placement-job/${id}/apply`,
    },
    landingPage: {
      getAll: "/user/home/getHomeData",
      getTopBanner: "/admin/Banner/bannerByPosition",
      updateBannerStatus: `/user/edit/profile`,
      getAllBannerVideos: "/user/Banner/allBanner",
    },
  },
};
